import React, { useContext, useState } from "react";
import MaterialTable from "material-table";
import { Edit } from "@material-ui/icons";
import { Checkbox, withStyles } from "@material-ui/core";
import { ICON_COLOUR } from "lib/constants/style_constants";
import tableIcons, { options } from "components/universal/table_attributes";
import PartSalesServices from "lib/services/api/commercial/parts";
import { ToastMessageContext } from "lib/contexts/message_context";
import { getOrganisationId } from "lib/utils/common_utils";
const GreenCheckbox = withStyles({
    root: {
        color: "#4FC605",
        '&$checked': {
            color: "#4FC605",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const TraceRequirements = ({ data = [], setData, getDefaultRequirement, coreId, action, coreLineTotal, disabled, writePermission }) => {


    const [selected, setSelected] = useState([])
    const message = useContext(ToastMessageContext)
    const tableOptions = {
        ...options,
        paging: false,
        toolbar: false,
        search: false,

    };

    const handleStatus = (id, checked) => {

        let value1 = data.map((item) => {

            if (item.id === id) {
                item.status = !item.status
            }
            return item
        })
        setData(value1)

    }


    const columns = [
        {
            title: "",
            field: "checkbox",
            render: (rowData) => <GreenCheckbox disabled={disabled} checked={rowData?.status} onChange={(e) => {
                handleStatus(rowData?.id, e.target.checked)
            }} />,
            editable: "never",
            width: "4%"
        },
        {
            title: "Code",
            field: "code",
            editable: "never"
        },

        {
            title: "Trace Document",
            field: "name",
            editable: "never",


            cellStyle: {
                textAlign: "left",
                width: "50%"
            },
            headerStyle: {
                textAlign: "left",
                width: "50%"
            }
        },

        {
            title: "Penalty %",
            field: "penalty_pc",
            type: "numeric",

        },
        {
            title: "Value",
            field: "value",
            editable: "never"
        },
        {
            title: "Currency",
            field: "currency",
            editable: "never"
        },

    ]
    const handleCalculation = (penalty) => {
        const p = parseFloat(penalty) || 0;
        const total = parseFloat(coreLineTotal) || 0;
        const result = (p / 100) * total;
        return result.toFixed(2) ?? 0
    };
    const handlePenaltyCore = async (newData, rowData) => {

        let value = data.map((item) => {
            if (item?.id === newData?.id) {
                return {
                    ...item,
                    penalty_pc: newData?.penalty_pc,
                    value: handleCalculation(newData?.penalty_pc)
                }
            }
            else {
                return item
            }

        })

        setData(value)


    }
    return (
        <MaterialTable
            title="Trace Requirements"
            columns={columns}
            data={data}
            options={tableOptions}
            icons={tableIcons}
            editable={{
                isEditable: (rowData) => rowData?.status === true,
                isEditHidden: (rowData) => rowData?.status === false || !writePermission,
                onRowUpdate: (newData, oldData, rowData) =>
                    new Promise((resolve, reject) => {
                        handlePenaltyCore(newData, rowData)
                        resolve();
                    }),
            }}

        />
    );
};

export default TraceRequirements;
